import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Pantalla de carga de marca RedMobility.
 *
 * Centraliza todos los estados de espera de la app para dar una experiencia
 * consistente cuando hay procesos que tardan o no se pueden optimizar
 * (descarga de chunks, verificación de sesión, llamadas al backend, etc.).
 *
 * Props:
 *  - message:  texto opcional bajo el spinner (por defecto "Cargando...").
 *  - inline:   si es true, ocupa solo su contenedor (útil con Navbar visible)
 *              en lugar de cubrir toda la pantalla.
 *  - className: clases extra (p. ej. min-height para variante inline).
 */
export default function LoadingScreen({ message, inline = false, className = '' }) {
  const { t } = useTranslation();
  const text = message ?? t('common.loading');

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy="true"
      className={`${
        inline
          ? 'flex flex-col items-center justify-center py-24'
          : 'fixed inset-0 z-50 flex flex-col items-center justify-center bg-white'
      } ${className}`}
    >
      {/* Spinner doble anillo en colores de marca */}
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 rounded-full border-4 border-[#36C0C7]/20" />
        <div className="absolute inset-0 rounded-full border-4 border-transparent border-t-[#36C0C7] border-r-[#134168] animate-spin" />
      </div>
      <p className="mt-5 text-sm font-semibold tracking-wide text-[#134168]">{text}</p>
      <span className="sr-only">{t('common.loading')}</span>
    </div>
  );
}
